<template>
  <!--左侧菜单-->
  <div class="col_1 w215 member_left_menu">
    <p v-for="item in menus" :key="item.id" :class="item.iconClass">
      <router-link :to="item.path" active-class="focus">{{item.name}}</router-link>
    </p>
  </div>
  <!--/左侧菜单-->
</template>
<script>
export default {
  name: 'Menu',
  props: ['menus']
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/menu/menu.vue